
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import BookingCalendar from '../../components/feature/BookingCalendar';

export default function RegistrazionePage() {
  const [showBooking, setShowBooking] = useState(false);
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-purple-50 to-violet-100 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-fill text-3xl text-white"></i>
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Registrazione all'Agenzia delle Entrate
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                Servizio completo di registrazione del contratto presso l'Agenzia delle Entrate, 
                con gestione di tutta la documentazione e le pratiche burocratiche.
              </p>
              <Button size="lg" className="cursor-pointer" onClick={() => setShowBooking(true)}>
                Richiedi Registrazione
              </Button>
            </div>
          </div>
        </section>

        {/* Perché Registrare */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Perché Registrare il Contratto
              </h2>
              <p className="text-xl text-gray-600">
                La registrazione è obbligatoria per legge e offre importanti vantaggi
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-scales-3-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Obbligo di Legge</h3>
                <p className="text-gray-600">La registrazione è obbligatoria entro 30 giorni dalla stipula del contratto</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-fill text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Validità Legale</h3>
                <p className="text-gray-600">Solo i contratti registrati hanno piena validità legale in caso di controversie</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-euro-circle-fill text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Agevolazioni Fiscali</h3>
                <p className="text-gray-600">Accesso a detrazioni fiscali e cedolare secca per il proprietario</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-shield-fill text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Protezione Legale</h3>
                <p className="text-gray-600">Tutela completa per entrambe le parti in caso di dispute o contenziosi</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-heart-fill text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Residenza Anagrafica</h3>
                <p className="text-gray-600">L'inquilino può stabilire la residenza solo con contratto registrato</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-archive-fill text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Archiviazione Ufficiale</h3>
                <p className="text-gray-600">Il contratto viene archiviato negli archivi ufficiali dello Stato</p>
              </div>
            </div>
          </div>
        </section>

        {/* Processo di Registrazione */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="bg-cover bg-center rounded-xl h-96" style={{
                backgroundImage: `url('/images/registrazione-detail.jpg')`
              }}></div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Il Nostro Processo di Registrazione
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-purple-600 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Preparazione Documentazione</h3>
                      <p className="text-gray-600">Riceviamo i documenti necessari per la registrazione</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-purple-600 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Calcolo Imposte</h3>
                      <p className="text-gray-600">Calcoliamo l'imposta di registro ( se dovuta )</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-purple-600 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Presentazione Telematica</h3>
                      <p className="text-gray-600">Presentiamo la pratica telematicamente all'Agenzia delle Entrate</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-purple-600 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Pagamento Imposte</h3>
                      <p className="text-gray-600">Gestiamo il pagamento delle imposte di registro ( se dovuta )</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-purple-600 font-bold">5</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Ricevuta di Registrazione</h3>
                      <p className="text-gray-600">Ti consegniamo la ricevuta ufficiale di avvenuta registrazione</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Documenti Necessari */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Documenti Necessari
              </h2>
              <p className="text-xl text-gray-600">
                Ecco cosa serve per completare la registrazione
              </p>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center">
                  <i className="ri-file-text-line text-purple-600 mr-3"></i>
                  Documentazione Richiesta
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="bg-purple-50 rounded-xl p-6 border border-purple-200">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-file-edit-line text-2xl text-purple-600"></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">
                      Contratto di Locazione
                    </h4>
                    <div className="space-y-3">
                      <div className="flex items-start">
                        <i className="ri-check-line text-purple-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Contratto firmato da tutte le parti</span>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-check-line text-purple-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Originale o copia conforme</span>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-check-line text-purple-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Completo di tutti gli allegati</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-user-line text-2xl text-blue-600"></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">
                      Documento di Identità
                    </h4>
                    <div className="space-y-3">
                      <div className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Del richiedente la registrazione</span>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Che deve essere parte del contratto</span>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-check-line text-blue-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">In corso di validità</span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-bank-line text-2xl text-green-600"></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">
                      IBAN per Pagamento Imposte
                    </h4>
                    <div className="space-y-3">
                      <div className="flex items-start">
                        <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Coordinate bancarie complete</span>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Per il pagamento delle imposte di registro</span>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                        <span className="text-gray-700">Se dovute in base al contratto</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-information-line text-yellow-600 mr-2"></i>
                    Importante
                  </h4>
                  <p className="text-gray-700">
                    Il richiedente della registrazione deve necessariamente essere una delle parti firmatarie del contratto 
                    (proprietario o inquilino). Non è possibile registrare un contratto per conto di terzi non coinvolti 
                    nella locazione.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Registra il Tuo Contratto Oggi
            </h2>
            <p className="text-xl text-purple-100 mb-8">
              Affidati ai nostri esperti per una registrazione veloce e senza errori
            </p>
            <Button variant="secondary" size="lg" className="cursor-pointer" onClick={() => setShowBooking(true)}>
              Inizia Registrazione
            </Button>
          </div>
        </section>
      </main>
      <Footer />
      <BookingCalendar isOpen={showBooking} onClose={() => setShowBooking(false)} />
    </div>
  );
}
